export default "__VITE_ASSET__JdIzuEY___"